import React from 'react'

export const IcoBin = ({style={}, cy=''}) => {
  return (
    <svg className='icon-bin' viewBox='0 0 48 48' style={style} data-cy={`IcoBin${cy}`}>
      <path d='M6 15v30c0 1.65 1.35 3 3 3h27c1.65 0 3-1.35 3-3v-30h-33zM15 42h-3v-21h3v21zM21 42h-3v-21h3v21zM27 42h-3v-21h3v21zM33 42h-3v-21h3v21z'></path>
      <path d='M39.75 6h-9.75v-3.75c0-1.237-1.013-2.25-2.25-2.25h-10.5c-1.237 0-2.25 1.013-2.25 2.25v3.75h-9.75c-1.238 0-2.25 1.012-2.25 2.25v3.75h39v-3.75c0-1.238-1.013-2.25-2.25-2.25zM27 6h-9v-2.962h9v2.962z'></path>
    </svg>
  )
}
